// Feature permissions removed - using only menuPermissions

// Menu data as a function that returns the menu structure
// State will be handled in the component that uses this data
export const getMenuData = () => {
    const menuItems: any = [
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-line",
            link: "/base",
        },
        {
            id: "reports",
            label: "Reports",
            icon: "ri-bar-chart-2-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "reports-overview",
                    label: "Übersicht",
                    link: "/reports",
                    parentId: "reports",
                    icon: "ri-dashboard-2-line",
                },
                {
                    id: "artlist-reports",
                    label: "Artlist Reports",
                    link: "/reports/artlist",
                    parentId: "reports",
                    icon: "ri-film-line",
                },
                {
                    id: "portfolio-reports",
                    label: "Portfolio Reports",
                    link: "/reports/portfolio",
                    parentId: "reports",
                    icon: "ri-briefcase-line",
                },
            ],
        },
        {
            id: "notifications",
            label: "Benachrichtigungen",
            icon: "ri-notification-3-line",
            link: "/notifications",
        },
        {
            label: "Projekte & Kalkulation",
            isHeader: true,
            headerClass: "header-projects",
        },
        {
            id: "projekte",
            label: "Projekte",
            icon: "ri-folder-2-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "projects1",
                    label: "Projektliste",
                    link: "/projects",
                    parentId: "projekte",
                },
                {
                    id: "projectsoverview",
                    label: "Projektleiter-Übersicht",
                    link: "/projects/overview",
                    parentId: "projekte",
                    icon: "ri-user-star-line",
                },
                {
                    id: "pitchplease",
                    label: "Pitch Please",
                    link: "/projects/pitch-please",
                    parentId: "projekte",
                    icon: "ri-lightbulb-line",
                },
                {
                    id: "projectgraveyard",
                    label: "Projekt-Friedhof 🪦",
                    link: "/projects/graveyard",
                    parentId: "projekte",
                    icon: "ri-skull-2-line",
                },
                {
                    id: "newproject",
                    label: "Neues Projekt",
                    link: "/projects/create",
                    parentId: "projekte",
                    icon: "ri-add-circle-line",
                }
            ],
        },
        {
            id: "kalkulationen",
            label: "Kalkulationen",
            icon: "ri-calculator-line",
            link: "/#",
            // permission removed - using menuPermissions only
            isExpandable: true,
            subItems: [
                {
                    id: "kalkulationlist",
                    label: "Kalkulationen Übersicht",
                    link: "/calculations",
                    parentId: "kalkulationen",
                },
                {
                    id: "kalkulationtemplates",
                    label: "Templates verwalten",
                    link: "/calculations-templates",
                    parentId: "kalkulationen",
                    icon: "ri-file-list-3-line",
                },
                {
                    id: "kalkulationcomments",
                    label: "Kalkulationskommentare",
                    link: "/calculation-comments",
                    parentId: "kalkulationen",
                    icon: "ri-chat-3-line",
                },
                {
                    id: "projecthoursoverview",
                    label: "Projekt-Stunden Übersicht",
                    link: "/calculations/hours",
                    parentId: "kalkulationen",
                    icon: "ri-team-line",
                },
            ],
        },
        {
            id: "estimates",
            label: "Kostenvoranschläge",
            icon: "ri-file-list-3-line",
            link: "/#",
            // permission removed - using menuPermissions only
            isExpandable: true,
            subItems: [
                {
                    id: "estimateslist",
                    label: "Kostenvoranschläge Übersicht",
                    link: "/estimates",
                    parentId: "estimates",
                },
                {
                    id: "estimatessettings",
                    label: "Einstellungen",
                    link: "/estimates/settings",
                    parentId: "estimates",
                    icon: "ri-settings-3-line",
                },
            ],
        },
        {
            id: "buyouts",
            label: "Buyouts",
            icon: "ri-copyright-line",
            link: "/#",
            // permission removed - using menuPermissions only
            isExpandable: true,
            subItems: [
                {
                    id: "buyoutlist",
                    label: "Buyouts / Rechteabtretung",
                    link: "/buyouts",
                    parentId: "buyouts",
                },
            ],
        },
        {
            id: "frameio",
            label: "Frame.io",
            icon: "ri-film-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "frameio-asset-explorer",
                    label: "Asset Explorer",
                    link: "/dev-tools/frameio-assets",
                    parentId: "frameio",
                },
                {
                    id: "frameio-uploader",
                    label: "Uploader",
                    link: "/dev-tools/frameio-uploader",
                    parentId: "frameio",
                    icon: "ri-upload-cloud-2-line",
                },
                {
                    id: "frameio-uploads",
                    label: "Uploads Liste",
                    link: "/dev-tools/frameio-uploads",
                    parentId: "frameio",
                    icon: "ri-list-check-2",
                },
                {
                    id: "frameio-my-reviews",
                    label: "Meine Reviews",
                    link: "/frameio/my-reviews",
                    parentId: "frameio",
                    icon: "ri-checkbox-multiple-line",
                },
            ],
        },
        {
            label: "Zeit & Team",
            isHeader: true,
            headerClass: "header-time-team",
        },
        {
            id: "zeiterfassung",
            label: "Zeiterfassung",
            icon: "ri-time-line",
            link: "/#",
            // permission removed - using menuPermissions only
            isExpandable: true,
            subItems: [
                {
                    id: "quicktimeentry",
                    label: "Zeiterfassung (Ctrl + T)",
                    link: "/time-entries/quick",
                    parentId: "zeiterfassung",
                    icon: "ri-add-circle-line",
                },
                {
                    id: "timeentries",
                    label: "Zeiteinträge",
                    link: "/time-entries",
                    parentId: "zeiterfassung",
                },
                {
                    id: "timeentryapprovals",
                    label: "Zeiteinträge Freigabe",
                    link: "/time-entries/approvals",
                    parentId: "zeiterfassung",
                    icon: "ri-checkbox-circle-line",
                    // permission removed - using menuPermissions only
                },
                {
                    id: "timesankey",
                    label: "Zeit-Sankey Analyse",
                    link: "/time-entries/sankey",
                    parentId: "zeiterfassung",
                    icon: "ri-flow-chart",
                },
                {
                    id: "hourscalendar",
                    label: "Stundenkalender",
                    link: "/time-entries/hours-calendar",
                    parentId: "zeiterfassung",
                    icon: "ri-calendar-2-line",
                },
                {
                    id: "allinerfassung",
                    label: "Headtracker",
                    link: "/allin-erfassung",
                    parentId: "zeiterfassung",
                },
                {
                    id: "allinerfassungproperson",
                    label: "Headtracker pP",
                    link: "/allin-erfassung-pro-person",
                    parentId: "zeiterfassung",
                },
                {
                    id: "kontingente",
                    label: "Kontingente",
                    link: "/kontingente",
                    parentId: "zeiterfassung",
                },
                {
                    id: "houradjustments",
                    label: "Kontingent-Anpassungen",
                    link: "/absences/hour-adjustments",
                    parentId: "zeiterfassung",
                    icon: "ri-settings-3-line",
                },
                {
                    id: "timetracker",
                    label: "Timetracker",
                    link: "/timetracker",
                    parentId: "zeiterfassung",
                    icon: "ri-dashboard-3-line",
                },
                {
                    id: "clock-history",
                    label: "Meine Clockzeiten",
                    link: "/clock/history",
                    parentId: "zeiterfassung",
                    icon: "ri-history-line",
                }
            ],
        },
        {
            id: "tasks",
            label: "Aufgaben",
            icon: "ri-task-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "taskboardvelzon",
                    label: "Tasks Kanban",
                    link: "/tasks",
                    parentId: "tasks",
                    icon: "ri-kanban-view",
                }
            ],
        },
        {
            id: "calendar",
            label: "Kalender",
            icon: "ri-calendar-line",
            link: "/calendar",
        },
        {
            id: "smart-office",
            label: "Smart Office",
            icon: "ri-home-smile-2-line",
            link: "/smart-office",
        },
        {
            id: "messages",
            label: "Messages",
            icon: "ri-message-3-line",
            link: "/messages",
        },
        {
            id: "absences",
            label: "Abwesenheiten",
            icon: "ri-user-forbid-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "vacationbalance",
                    label: "Abwesenheitskontingente",
                    link: "/absences/vacation-balance",
                    parentId: "absences",
                    icon: "ri-wallet-3-line",
                },
                {
                    id: "absencerequest",
                    label: "Abwesenheitsantrag",
                    link: "/absences/request",
                    parentId: "absences",
                    icon: "ri-add-circle-line",
                },
                {
                    id: "absencecalendar",
                    label: "Abwesenheitskalender",
                    link: "/absences/calendar",
                    parentId: "absences",
                    icon: "ri-calendar-line",
                },
                {
                    id: "contingentadjustment",
                    label: "Abwesenheitskontingent-Anpassungen",
                    link: "/absences/adjustments",
                    parentId: "absences",
                    icon: "ri-settings-3-line",
                },
                {
                    id: "absencerequests",
                    label: "Abwesenheitsanfragen",
                    link: "/absences/requests",
                    parentId: "absences",
                    icon: "ri-file-list-3-line",
                },
            ],
        },
        {
            label: "Kunden & Finanzen",
            isHeader: true,
            headerClass: "header-finance",
        },
        {
            id: "documentcapture",
            label: "Dokumente erfassen",
            icon: "ri-scan-line",
            link: "/document-capture",
        },
        {
            id: "documentreview",
            label: "Dokumente prüfen",
            icon: "ri-file-search-line",
            link: "/document-review",
            requiredPermission: "document_capture_review",
        },
        {
            id: "emails",
            label: "E-Mail Eingang",
            icon: "ri-mail-line",
            link: "/emails",
        },
        {
            id: "mydocuments",
            label: "Meine Dokumente",
            icon: "ri-folder-user-line",
            link: "/my-documents",
        },
        {
            id: "paymentreminders",
            label: "Mahnwesen",
            icon: "ri-error-warning-line",
            link: "/payment-reminders/overdue",
        },
        {
            id: "customers",
            label: "Kunden",
            icon: "ri-group-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "customerlist",
                    label: "Kunden Übersicht",
                    link: "/customers",
                    parentId: "customers",
                },
                {
                    id: "kvcontrolling",
                    label: "KV-Controlling",
                    link: "/customers/kv-controlling",
                    parentId: "customers",
                    icon: "ri-file-chart-line",
                },
            ],
        },
        {
            id: "invoices",
            label: "Rechnungen",
            icon: "ri-bill-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "invoiceslist",
                    label: "Ausgangsrechnungen",
                    link: "/invoices",
                    parentId: "invoices",
                },
                {
                    id: "incominginvoices",
                    label: "Eingangsrechnungen",
                    link: "/incoming-invoices",
                    parentId: "invoices",
                },
                {
                    id: "myapprovals",
                    label: "Meine Freigaben",
                    link: "/my-approvals",
                    parentId: "invoices",
                    icon: "ri-check-double-line",
                },
                {
                    id: "paymentterminal",
                    label: "Payment Terminal",
                    link: "/payment-terminal",
                    parentId: "invoices",
                    icon: "ri-bank-card-line",
                },
                {
                    id: "receipts",
                    label: "Belege",
                    link: "/receipts",
                    parentId: "invoices",
                    icon: "ri-receipt-line",
                },
                {
                    id: "cashbook",
                    label: "Kassabuch",
                    link: "/cashbook",
                    parentId: "invoices",
                    icon: "ri-money-euro-box-line",
                },
                {
                    id: "vendors",
                    label: "Lieferanten",
                    link: "/vendors",
                    parentId: "invoices",
                    icon: "ri-building-line",
                },
                {
                    id: "expensereports",
                    label: "Verrechnungsgeld / Belegabrechnung",
                    link: "/expense-reports",
                    parentId: "invoices",
                    icon: "ri-file-list-3-line",
                },
            ],
        },
        {
            id: "subscriptions",
            label: "Subscriptions",
            icon: "ri-calendar-check-line",
            link: "/subscriptions",
        },
        {
            id: "turnovers",
            label: "Turnovers",
            icon: "ri-exchange-dollar-line",
            link: "/#",
            // permission removed - using menuPermissions only
            isExpandable: true,
            subItems: [
                {
                    id: "turnoverlist",
                    label: "Turnover Übersicht",
                    link: "/turnovers",
                    parentId: "turnovers",
                },
            ],
        },
        {
            id: "bankstatements",
            label: "Bankauszüge",
            icon: "ri-bank-line",
            link: "/bank-statements",
        },
        {
            id: "creditcards",
            label: "Kreditkarten",
            icon: "ri-bank-card-line",
            link: "/credit-cards",
        },
        {
            id: "monthlyreport",
            label: "Monatsabrechnung",
            icon: "ri-file-chart-line",
            link: "/monthly-report",
        },
        {
            label: "Verwaltung",
            isHeader: true,
            headerClass: "header-management",
        },
        {
            id: "user",
            label: "Benutzer",
            icon: "ri-user-settings-line",
            link: "/#",
            // permission removed - using menuPermissions only
            isExpandable: true,
            subItems: [
                {
                    id: "userlist",
                    label: "Benutzerliste",
                    link: "/users",
                    parentId: "user",
                },
                {
                    id: "createuser",
                    label: "Neuer Mitarbeiter",
                    link: "/users/create",
                    parentId: "user",
                    icon: "ri-user-add-line",
                },
                {
                    id: "onboarding",
                    label: "Onboarding Dashboard",
                    link: "/users/onboarding",
                    parentId: "user",
                    icon: "ri-user-follow-line",
                },
                {
                    id: "userroles",
                    label: "Rollen & Berechtigungen",
                    link: "/user-roles",
                    parentId: "user",
                },
                {
                    id: "hr-incidents",
                    label: "Mitteilungsheft",
                    link: "/hr/incidents",
                    parentId: "user",
                    icon: "ri-file-warning-line",
                    requiredRole: ["admin"],
                },
                {
                    id: "document-templates",
                    label: "Dokumentvorlagen",
                    link: "/document-templates",
                    parentId: "user",
                    icon: "ri-file-text-line",
                },
            ],
        },
        {
            id: "asset-management",
            label: "Sachverwaltung",
            icon: "ri-briefcase-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "fleet-management",
                    label: "Schlüsselverwaltung",
                    link: "/fleet-management",
                    parentId: "asset-management",
                    icon: "ri-key-2-line",
                },
                {
                    id: "userdevices",
                    label: "Geräteverwaltung",
                    link: "/user-devices",
                    parentId: "asset-management",
                    icon: "ri-computer-line",
                },
            ],
        },
        {
            label: "Wissen & Kommunikation",
            isHeader: true,
            headerClass: "header-knowledge",
        },
        {
            id: "news",
            label: "News",
            icon: "ri-newspaper-line",
            link: "/news",
        },
        {
            id: "notes",
            label: "Notizen",
            icon: "ri-sticky-note-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "notes-list",
                    label: "Meine Notizen",
                    link: "/notes",
                    parentId: "notes",
                },
                {
                    id: "prompt-designer",
                    label: "Prompt Designer",
                    link: "/notes/prompt-designer",
                    parentId: "notes",
                    icon: "ri-settings-3-line",
                }
            ],
        },
        {
            id: "wiki",
            label: "Wiki",
            icon: "ri-book-2-line",
            link: "/#",
            isExpandable: true,
            subItems: [
                {
                    id: "wikiOverview",
                    label: "Wiki Übersicht",
                    link: "/wiki",
                    parentId: "wiki",
                },
            ],
        },
        {
            id: "password-manager",
            label: "Password Manager",
            icon: "ri-lock-password-line",
            link: "/password-manager",
        },
        {
            label: "Administration",
            isHeader: true,
            headerClass: "header-admin",
        },
        {
            id: "admin-monitoring",
            label: "Live Monitoring",
            icon: "ri-dashboard-3-line",
            link: "/admin/monitoring",
        },
        {
            id: "clock-management",
            label: "Clock Management",
            icon: "ri-time-line",
            link: "/admin/clock-management",
        },
        {
            id: "forgotten-clocks",
            label: "Vergessene Clocks",
            icon: "ri-error-warning-line",
            link: "/admin/forgotten-clocks",
        },
        {
            id: "clock-corrections",
            label: "Korrekturanträge",
            icon: "ri-file-edit-line",
            link: "/admin/clock-corrections",
        },
        {
            id: "news-management",
            label: "News-Verwaltung",
            icon: "ri-newspaper-line",
            link: "/admin/news",
        },
        {
            id: "external-door-access",
            label: "Externe Türzugänge",
            icon: "ri-door-lock-line",
            link: "/admin/external-door-access",
        },
        {
            label: "Tools & Entwicklung",
            isHeader: true,
            headerClass: "header-tools",
        },
        {
            id: "speaker-settings",
            label: "Speaker Durchsagen",
            icon: "ri-volume-up-line",
            link: "/dev-tools/speaker",
        },
        {
            id: "sqlimport-direct",
            label: "SQL Import",
            icon: "ri-database-2-line",
            link: "/dev-tools/sql-import",
        },
        {
            id: "user-password-override",
            label: "Password Hacker",
            icon: "ri-lock-unlock-line",
            link: "/dev-tools/user-password-override",
        },
        {
            id: "api-tokens",
            label: "API Tokens",
            icon: "ri-key-2-line",
            link: "/dev-tools/api-tokens",
        },
        {
            id: "database-insights",
            label: "Database Insights",
            icon: "ri-dashboard-3-line",
            link: "/dev-tools/database-insights",
        },
        {
            id: "system-logs",
            label: "System Logs",
            icon: "ri-file-list-3-line",
            link: "/dev-tools/logs",
        },
        {
            id: "kv-generator",
            label: "KV Generator",
            icon: "ri-magic-line",
            link: "/dev-tools/kv-generator",
        },
        {
            id: "bug-reports",
            label: "Bug Reports",
            icon: "ri-bug-line",
            link: "/dev-tools/bug-reports",
        },
        {
            id: "door-access-logs",
            label: "Türzugriffs-Logs",
            icon: "ri-door-open-line",
            link: "/admin/door-access-logs",
        },
        {
            id: "calculation-saves",
            label: "Calculation Saves",
            icon: "ri-save-3-line",
            link: "/dev-tools/calculation-saves",
        },
        {
            id: "customer-duplicates",
            label: "Kunden-Duplikate",
            icon: "ri-merge-cells-horizontal",
            link: "/dev-tools/customer-duplicates",
        },
        {
            id: "backup-monitor",
            label: "Backup Monitor",
            icon: "ri-shield-check-line",
            link: "/dev-tools/backup-monitor",
        },
        {
            id: "nas-storage",
            label: "NAS Storage",
            icon: "ri-hard-drive-2-line",
            link: "/dev-tools/nas-storage",
        },
        {
            id: "version-history",
            label: "Version History",
            icon: "ri-history-line",
            link: "/version-history",
        },
    ];
    return menuItems;
};

// Default export for backward compatibility
export default getMenuData;